export default Object.freeze({
  STEPS: [
    {
      target: '#v-step-0',
      content: 'この画面では日報の登録ができます。<br>登録までのガイドが必要な場合は[次へ]を押してください。<br>すぐに始める場合は[操作ガイド終了]を押してください。',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    },
    {
      target: '#v-step-1',
      content: '運行日を入力しましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'right'
      }
    },
    {
      target: '#v-step-2',
      content: '売上を計上する営業所を入力しましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'right'
      }
    },
    {
      target: '#v-step-3',
      content: '[受注情報を新規追加する]を押下すると受注が登録できる画面が開きます<br>画面が開いたら[次へ]を押してください<br>※画面が開く前に[次へ]を押すとガイドが終了しますのでご注意ください',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    },
    {
      target: '#v-step-4',
      content: '請求を計上する営業所を入力しましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'right'
      }
    },
    {
      target: '#v-step-5',
      content: '顧客を入力しましょう。<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'right'
      }
    },
    {
      target: '#v-step-6',
      content: '発着地を入力しましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    },
    {
      target: '#v-step-7',
      content: '商品に関する入力をしましょう<br>運賃は後述の運賃計算方法により以下の通り自動計算されます。<br>必要に応じて入力してください。<br>1.個建(数量)：数量×単価<br>2.個建(重量)：重量×単価<br>3.車建:単価<br><br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    },
    {
      target: '#v-step-8',
      content: '請求に関する入力をしましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: true,
        placement: 'top'
      }
    },
    {
      target: '#v-step-9',
      content: '[保存する]で受注の登録が完了です。<br>登録完了後に画面が閉じます。<br>画面が閉じたら[次へ]を押してください。',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    },
    {
      target: '#v-step-10',
      content: '乗務員の勤務時間や車両の入出庫に関する情報が入力できます。<br>入力したら[次へ]を押してください。',
      params: {
        enableScrolling: true,
        placement: 'top'
      }
    },
    {
      target: '#v-step-save',
      content: '[保存する]で日報の登録が完了です。',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    }
  ]
})
